import SetPassword from './SetPassword'

export default SetPassword('Zapomenuté heslo')



// WEBPACK FOOTER //
// ./src/screens/AccountForgottenPassword.tsx